import Emitter from './Emitter';
import { Events } from './Constants';
/**
 * @class
 * @description Communication class that uses XHR requests.
 * It has events for the different expected received messages and the method send.
 * @extends Emitter
 * @exports XhrRequest
 */
export default class XhrRequest extends Emitter {
    /**
     * Constructs XhrRequest.
     * @param {string} host Host url
     * @param {string} service Service (endpoint) URL.
     * @param {XMLHttpRequestResponseType} respType Optional response type.
     * @param {string} method Request method, by default GET.
     */
    constructor(host, service, respType, method) {
        super();
        this._host = host;
        this._service = service;
        this._req = new XMLHttpRequest();
        if (respType) {
            this._req.responseType = respType;
        }
        this._method = method || 'GET';
    }
    /**
     * Sends the request built.
     * @param {messageParams} message Optional object of parameters that will be sent as url parameters.
     * @param {Object} headers Optional headers for the request.
     * @param {Object} body Request body.
     * @param {boolean} secure Optional to force the request to be https.
     * @public
     */
    send(message = '', headers = {}, body = undefined, secure) {
        const parameters = typeof message === 'string' ? message : XhrRequest._buildParams(message);
        const http = XhrRequest._isSecure || secure ? 'https://' : 'http://';
        this._req.open(this._method, `${http}${this._host}${this._service}${parameters}`, true);
        for (const a in headers) {
            this._req.setRequestHeader(a, headers[a]);
        }
        // this._req.setRequestHeader('Access-Control-Expose-Headers', 'accept-ranges');
        // this._req.setRequestHeader('Access-Control-Allow-Headers', 'range');
        //   this._req.setRequestHeader('Access-Control-Expose-Headers', 'Accept-Ranges, Content-Encoding, Content-Length, Content-Range');
        // this._req.setRequestHeader('Access-Control-Allow-Origin', '*');
        // headers.append('Access-Control-Allow-Origin', 'http://localhost:3000');
        // headers.append('Access-Control-Allow-Credentials', 'true');
        this._req.addEventListener('readystatechange', () => {
            const response = this._req.response;
            switch (this._req.readyState) {
                case 4: //Done
                    this.emit(Events.Get.Success, { response });
                    break;
                case 3: // Loading
                    // case 2: // Headers received
                    this.emit(Events.Get.Progress, { response });
                    break;
            }
        });
        this._req.addEventListener('loadend', () => {
            if (!this._req.status || this._req.status >= 400) {
                this.emit(Events.Get.Fail);
            }
        });
        this._req.send(body);
    }
    /**
     * Returns the XHR object.
     * @returns {XMLHttpRequest} XHR request object.
     * @public
     */
    getXHR() {
        return this._req;
    }
    /**
     * Given a messageParams object builds a string to send them as URL params.
     * @param {messageParams} message Params object.
     * @returns {string} URL parameters.
     * @private
     * @static
     */
    static _buildParams(message) {
        let params = '?';
        try {
            for (const key in message) {
                const param = message[key];
                if (param !== null && typeof param !== 'undefined' && param !== '') {
                    params += `${encodeURIComponent(key)}=${encodeURIComponent(param)}&`;
                }
            }
            params = params.slice(0, -1);
        }
        catch (err) {
            params = '';
        }
        return params;
    }
}
XhrRequest._isSecure = 'undefined' !== typeof location ? location.protocol === 'https:' : false;
